import { View } from "./View";

export const Checkbox = (props: any) => {
  return <View {...props} />;
};
